import React from 'react';
import { Match as DefaultMatch } from '@g-loot/react-tournament-brackets';
import { useNavigate } from 'react-router-dom';

const ClickableMatch = (props) => {
  const navigate = useNavigate();
  const isClickable = props.match.gamestatuscode === 2;

  const handleClick = () => {
    const matchId = props.match.gamecode;
    if (isClickable) {
      navigate(`/game/${matchId}`);
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{ cursor: isClickable ? 'pointer' : 'default' }}
    >
      <DefaultMatch {...props} />
    </div>
  );
};

export default ClickableMatch;